module.exports = __webpack_public_path__ + "img/icon_bell_notification_ting_pink.42b2b55f.svg";